import moreBar from '@/views/echarts/bar/components/moreBar';
import radiusPie from '@/views/echarts/pie/components/radiusPie';
import remoteLoad from '@/utils/remoteLoad';
const {
  html2canvasCDN
} = require('@/plugins/cdn');
export default {
  components: {
    moreBar,
    radiusPie
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        await remoteLoad(html2canvasCDN);
        if (!window.html2canvas) {
          this.$message.error(this.$t('加载资源失败'));
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error);
      }
    },
    handleScreen() {
      this.loading = true;
      const boxDom = this.$refs.cutScreen;
      window.html2canvas(boxDom).then(res => {
        var dataUrl = res.toDataURL('image/jpeg', 1.0);
        var a = document.createElement('a');
        a.href = dataUrl;
        a.download = 'htmlcanvas2.png';
        a.click();
        this.loading = false;
      });
    }
  }
};